export default __webpack_public_path__ + "static/media/form.58c290d1.svg";